import { render, staticRenderFns } from "./copyable_field.vue?vue&type=template&id=f3263ef4"
import script from "./copyable_field.vue?vue&type=script&lang=js"
export * from "./copyable_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports